module.exports = __webpack_public_path__ + "506160c91ee73b2eaa394f8302644c98.PNG";